module.exports = __webpack_public_path__ + "img/Stapler_2t.9f8966f1.svg";